import React from "react";
import { Button } from "react-admin";

import { copyQrCodeToNavigator } from "../../utils/user";

import "./MfaQrCode.css";

type MfaQrCodeProps = {
  qrImage: string | undefined;
  code: string | undefined;
};

const MfaQrCode: React.FC<MfaQrCodeProps> = ({ qrImage, code }) => {
  const copyQrCode = () => {
    copyQrCodeToNavigator(code || "");
  };

  return (
    <div className="c-mfa-set-up-data">
      <img className="" src={qrImage || ""} />
      <Button onClick={copyQrCode}>
        <span>Copy key</span>
      </Button>
    </div>
  );
};

export default MfaQrCode;
